import { useState } from "react";
import {
  CLOUDINARY_PRESET,
  CLOUDINARY_UPLOAD_FOLDER,
  CLOUDINARY_URL,
  MAX_FILE_SIZE,
} from "../utils/constants";
import { CloudinaryUploadResponse } from "../utils/types";

export const useFileUpload = () => {
  const [uploadedFiles, setUploadedFiles] = useState<File[]>();
  const [uploadedFile, setUploadedFile] = useState<File>();
  const [uploadedFileUrl, setUploadedFileUrl] = useState<string>();
  const [error, setError] = useState<string>();
  const [uploading, setUploading] = useState(false);

  const handleSingleFileUpload = (
    uploaded: FileList | File[],
    callback: (url: string) => void,
    cloudUpload: boolean = true
  ) => {
    setError(undefined);

    const files = Array.from(uploaded);

    const fileSizesMB = Array.from(files).map((file: File) => file.size);

    if (fileSizesMB.some((size) => size > MAX_FILE_SIZE)) {
      setError(`File size too large`);
      return;
    }

    const uploadedImageFile = files[0];

    setUploadedFile(uploadedImageFile);

    if (cloudUpload) {
      const formData = new FormData();
      formData.append("file", uploadedImageFile);
      formData.append("upload_preset", CLOUDINARY_PRESET);
      formData.append("folder", CLOUDINARY_UPLOAD_FOLDER);

      setUploading(true);

      fetch(CLOUDINARY_URL ?? "", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data: CloudinaryUploadResponse) => {
          setUploadedFileUrl(data.url);
          setUploading(false);
          callback(data.url.replace("http:", "https:"));
        })
        .catch((error) => {
          console.error("Error uploading file:", error);
          setError("Error uploading file");
          setUploading(false);
        });
    }
  };

  const handleMultipleFileUpload = (uploaded: FileList) => {
    setError(undefined);

    const files = Array.from(uploaded);

    const fileSizesMB = Array.from(files).map((file: File) => file.size);

    if (fileSizesMB.some((size) => size > MAX_FILE_SIZE)) {
      setError(
        `Each file size should not exceed ${MAX_FILE_SIZE / (1024 * 1024)}MB`
      );
      return;
    }

    setUploadedFiles(files);
  };

  return {
    uploadedFile,
    uploadedFiles,
    handleSingleFileUpload,
    handleMultipleFileUpload,
    uploading,
    uploadedFileUrl,
    error,
  };
};
